import { Callout, FormField, RadioGroup, RadioBox } from '@dev-spendesk/grapes';
import React, { useId } from 'react';

import type { CostCenter } from 'modules/budgets/models/costCenter';
import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { MultipleCostCenterAutocomplete } from '../../../cost-centers/components/MultipleCostCenterAutocomplete';
import { type ExpenseCategory } from '../../expenseCategory';

type Props = {
  costCenters: CostCenter[];
  expenseCategories: ExpenseCategory[];
  costCenterAssignationType: 'all' | 'some';
  onCostCenterAssignationTypeChange: (value: 'all' | 'some') => void;
  costCenterIds: string[];
  onCostCenterIdsChange: (ids: string[]) => void;
};

export const EcBulkAssignModalContent = ({
  costCenters,
  expenseCategories,
  costCenterAssignationType,
  onCostCenterAssignationTypeChange,
  costCenterIds,
  onCostCenterIdsChange,
}: Props) => {
  const { t } = useTranslation('global');
  const radioGroupId = useId();

  const validCostCenterIds = costCenterIds.filter((id) =>
    costCenters.some((cc) => cc.id === id),
  );

  return (
    <>
      <Callout
        className="mb-24"
        variant="info"
        title={t('expenseCategories.bulkAssign.description', {
          count: expenseCategories.length,
        })}
      />

      <div className="mb-8 text-left">
        <FormField
          label={t('expenseCategories.form.costCenterAssignationFieldName')}
          description={t(
            'expenseCategories.form.costCenterAssignationFieldDescription',
          )}
        >
          <RadioGroup
            aria-labelledby={radioGroupId}
            name="costCenterAssignationType"
            value={costCenterAssignationType}
            onChange={(event) => {
              onCostCenterAssignationTypeChange(
                event.target.value as 'all' | 'some',
              );
            }}
          >
            <RadioBox
              value="all"
              label={t('expenseCategories.form.costCenterAssignation.all')}
            />
            <RadioBox
              value="some"
              label={t('expenseCategories.form.costCenterAssignation.some')}
            />
          </RadioGroup>
        </FormField>
      </div>

      {costCenterAssignationType === 'some' && (
        <>
          <FormField
            className="text-left"
            label={t('misc.costCenter')}
            visuallyHideLabel
          >
            <MultipleCostCenterAutocomplete
              costCenters={costCenters}
              selectedCostCenterIds={validCostCenterIds}
              onSelect={(options) => {
                onCostCenterIdsChange(options.map((option) => option.key));
              }}
            />
          </FormField>
          <Callout
            className="mt-8"
            title={t('expenseCategories.form.onlyRequestors')}
            variant="info"
          />
        </>
      )}
    </>
  );
};
